<template>
    <div class="max-w-xl mx-auto">
        <bubbleBox
            :greetText="$t('bof.login.greet')"
            :greetTextClass="'text-darkGrayishBlue'"
            class="mb-8 mt-4"
            :image="bubbleImg"
        >
            <form class="text-lg py-8 px-4 sm:pt-8 sm:pb-4 sm:px-16">
                <formFieldRow
                    name="userId"
                    :label="$t('bof.userId')"
                    labelWidthClass="sm:w-20 text-darkGrayishBlue"
                    :errors="errors"
                >
                    <template #default="{hasError}">
                        <input
                            name="userId"
                            class="form-input"
                            :class="{ 'border-red': hasError }"
                            type="text"
                            autocomplete="one-time-code"
                            v-model.trim="form.userId"
                            @keydown.enter="$refs.password.focus"
                        />
                    </template>
                </formFieldRow>
                <formFieldRow
                    name="password"
                    :label="$t('bof.password')"
                    labelWidthClass="sm:w-20 text-darkGrayishBlue"
                    :errors="errors"
                >
                    <template #default="{hasError}">
                        <div class="flex flex-col sm:flex-col-reverse">
                            <div class="text-sm text-darkGrayishBlue">
                                {{ $t('login.password.hint') }}
                            </div>
                            <input
                                name="password"
                                class="form-input"
                                :class="{ 'border-red': hasError }"
                                type="password"
                                ref="password"
                                autocomplete="one-time-code"
                                v-model.trim="form.password"
                                @keydown.enter="login"
                            />
                        </div>
                    </template>
                </formFieldRow>
            </form>
        </bubbleBox>
        <errorBox :message="errors.server" class="-mt-4" />

        <loadingButton
            class="py-2 px-8 bg-primary font-black w-full justify-center"
            :status="status"
            @click="login"
        >
            {{ $t('login.login') }}
        </loadingButton>
    </div>
</template>

<script>
import loadingButton from '@/components/loadingButton.vue';
import bubbleBox from '@/components/bubbleBox.vue';
import formFieldRow from '@/components/formFieldRow.vue';
import { validate } from '@/utils/validationUtil';
import errorBox from '@/components/errorBox.vue';
import { wait } from '@/utils/promiseUtil';
import img2s112 from '@/assets/img/2-112.png';

export default {
    components: {
        formFieldRow,
        loadingButton,
        bubbleBox,
        errorBox
    },
    data() {
        return {
            form: {
                userId: undefined,
                password: undefined
            },
            errors: {},
            status: undefined
        };
    },
    created() {
        this.bubbleImg = img2s112;
    },
    methods: {
        async login() {
            this.errors = {};
            const v = validate(this.errors, this.form, {
                userId: { required: true },
                password: { required: true }
            });
            if (v.hasError) {
                this.errors = v.errors;
                return;
            }
            this.status = 'loading';
            let result = await wait(
                () => this.$store.dispatch('bofLogin', this.form),
                500
            );
            if (result.success) {
                this.$router.push({ name: 'companyQuickJoin' });
            } else {
                this.status = undefined;
                this.errors = result.data.errors;
            }
        }
    }
};
</script>
